import { REQUIRED_FIELDS } from "../actions/requiredAction";

const initialState = {
  fields: [],
};

const requiredReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUIRED_FIELDS:
      return {
        ...state,
        fields: payload,
      };

    default:
      return state;
  }
};

export default requiredReducer;
